<div class="modal-header-modern">
  <div class="modal-header-icon icon-purple">
    <i class="material-icons">favorite</i>
  </div>
  <div>
    <h4 class="modal-title-modern">Acompanhamento entre sessões</h4>
    <p class="modal-subtitle-modern">{{ nomeCliente || 'Carregando...' }}</p>
  </div>
  <button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
    <i class="material-icons">close</i>
  </button>
</div>

<div class="modal-body">
  <ngx-loading [show]="loading"></ngx-loading>

  <div *ngIf="erro" class="info-hint erro-hint">
    <i class="material-icons">error_outline</i>
    <span>{{ erro }}</span>
  </div>

  <div *ngIf="!loading && resumo as r" class="acomp-modal-body">

    <!-- Alertas -->
    <div *ngIf="r.alertas.length > 0" class="resumo-alertas">
      <div *ngFor="let a of r.alertas" class="resumo-alerta">
        <i class="material-icons">warning_amber</i>{{ a }}
      </div>
    </div>

    <!-- Próxima sessão -->
    <div class="resumo-bloco">
      <h6>Próxima sessão</h6>
      <p *ngIf="r.proximoAtendimento as p; else semSessao">
        <strong>{{ p.dataHoraInicio | date: "EEEE, dd 'de' MMM · HH:mm" }}</strong><br />
        <small>{{ p.nomeServico || 'Sessão' }}{{ p.nomeClinica ? ' · ' + p.nomeClinica : '' }}</small>
      </p>
      <ng-template #semSessao>
        <p class="resumo-vazio">Sem sessão nos próximos 60 dias.</p>
      </ng-template>
    </div>

    <!-- Check-ins -->
    <div class="resumo-bloco">
      <h6>Check-ins (últimos 14 dias)</h6>
      <p *ngIf="!r.clienteUsaEasyPaciente" class="resumo-vazio">
        Este cliente ainda não usa o Easy Paciente.
      </p>
      <ng-container *ngIf="r.clienteUsaEasyPaciente">
        <div class="resumo-indicadores">
          <div>
            <span class="ind-label">Registros</span>
            <strong>{{ r.indicadores.quantidade }}</strong>
          </div>
          <div>
            <span class="ind-label">Humor</span>
            <strong>{{ r.indicadores.mediaHumor ? (r.indicadores.mediaHumor | number: '1.1-1') : '–' }}</strong>
          </div>
          <div>
            <span class="ind-label">Ansiedade</span>
            <strong>{{ r.indicadores.mediaAnsiedade ? (r.indicadores.mediaAnsiedade | number: '1.1-1') : '–' }}</strong>
          </div>
          <div>
            <span class="ind-label">Sono</span>
            <strong>{{ r.indicadores.mediaSono ? (r.indicadores.mediaSono | number: '1.1-1') : '–' }}</strong>
          </div>
        </div>
        <ul class="resumo-checkins" *ngIf="r.ultimosCheckIns.length > 0">
          <li *ngFor="let c of r.ultimosCheckIns">
            <span class="ck-data">{{ c.data | date: 'dd/MM' }}</span>
            <span class="ck-emoji">{{ emojiHumor(c.humor) }}</span>
            <small class="ck-metricas">Humor {{ c.humor }} · Ansiedade {{ c.ansiedade }} · Sono {{ c.sono }}</small>
            <em *ngIf="c.observacao">"{{ c.observacao }}"</em>
          </li>
        </ul>
        <p *ngIf="r.ultimosCheckIns.length === 0" class="resumo-vazio">Sem check-ins na janela.</p>
      </ng-container>
    </div>

    <!-- Última evolução -->
    <div class="resumo-bloco" *ngIf="r.ultimaEvolucao as e">
      <h6>Última evolução</h6>
      <p>
        <strong>{{ e.titulo }}</strong><br />
        <small>{{ e.dataCriacao | date: 'dd/MM/yyyy' }}</small>
      </p>
    </div>

    <!-- Tarefas terapêuticas -->
    <div class="resumo-bloco tarefas-bloco">
      <div class="tarefas-bloco__header">
        <h6>Tarefas terapêuticas</h6>
        <div class="tarefas-bloco__acoes">
          <button type="button" class="btn-modern btn-modern-outline btn-sm" (click)="toggleModelos()">
            <i class="material-icons">library_books</i>
            Modelos ({{ modelos.length }})
          </button>
          <button *ngIf="!mostrarFormularioTarefa"
                  type="button"
                  class="btn-modern btn-modern-primary btn-sm"
                  (click)="abrirFormularioTarefa()">
            <i class="material-icons">add</i>
            Nova tarefa
          </button>
        </div>
      </div>

      <!-- Biblioteca de modelos -->
      <div class="modelos-bloco" *ngIf="mostrarModelos">
        <div class="modelos-bloco__header">
          <span class="tarefas-secao__label">Biblioteca de modelos</span>
          <button *ngIf="!mostrarFormularioModelo" type="button"
                  class="btn-modern btn-modern-outline btn-sm" (click)="abrirFormularioModelo()">
            <i class="material-icons">add</i> Novo modelo
          </button>
        </div>

        <!-- Formulário de novo modelo -->
        <form *ngIf="mostrarFormularioModelo" [formGroup]="novoModeloForm" class="nova-tarefa-form" (ngSubmit)="salvarNovoModelo()">
          <div class="row">
            <mat-form-field class="col-xl-12" appearance="outline">
              <mat-label>Título do modelo</mat-label>
              <input matInput formControlName="titulo" required maxlength="150" placeholder="Ex.: Exercício de respiração diafragmática" />
              <mat-error *ngIf="novoModeloForm.controls['titulo'].hasError('required')">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-xl-12" appearance="outline">
              <mat-label>Descrição / instruções (opcional se gravar áudio)</mat-label>
              <textarea matInput formControlName="descricao" rows="3" maxlength="2000"
                        placeholder="Instruções padrão do modelo..."></textarea>
            </mat-form-field>
          </div>
          <div class="nova-tarefa-form__audio">
            <span class="nova-tarefa-form__audio-label">Orientação em áudio (opcional)</span>
            <app-audio-recorder rotuloGravar="Gravar orientação"
                                (gravado)="aoGravarAudioModelo($event)"></app-audio-recorder>
          </div>

          <div class="nova-tarefa-form__anexos">
            <span class="nova-tarefa-form__audio-label">Materiais de apoio (opcional)</span>
            <div class="tarefa-anexos__lista" *ngIf="anexosPendentesModelo.length || linksPendentesModelo.length">
              <div class="tarefa-anexo" *ngFor="let f of anexosPendentesModelo; let i = index">
                <span class="tarefa-anexo__item"><i class="material-icons">description</i>{{ f.name }}</span>
                <button type="button" class="tarefa-anexo__remover" (click)="removerAnexoPendenteModelo(i)" title="Remover"><i class="material-icons">close</i></button>
              </div>
              <div class="tarefa-anexo" *ngFor="let l of linksPendentesModelo; let i = index">
                <span class="tarefa-anexo__item"><i class="material-icons">link</i>{{ l.titulo || l.url }}</span>
                <button type="button" class="tarefa-anexo__remover" (click)="removerLinkPendenteModelo(i)" title="Remover"><i class="material-icons">close</i></button>
              </div>
            </div>
            <div class="tarefa-anexos__acoes">
              <label class="btn-modern btn-modern-outline btn-sm anexo-file-label">
                <i class="material-icons">attach_file</i> Anexar arquivo
                <input type="file" accept="image/*,application/pdf" hidden (change)="onArquivoNovoModelo($event)" />
              </label>
              <button type="button" class="btn-modern btn-modern-outline btn-sm" (click)="mostrarLinkFormNovoModelo = !mostrarLinkFormNovoModelo">
                <i class="material-icons">link</i> Adicionar link
              </button>
            </div>
            <div class="tarefa-anexos__link-form" *ngIf="mostrarLinkFormNovoModelo">
              <input type="url" placeholder="https://..." [(ngModel)]="novoModeloLinkUrl" [ngModelOptions]="{standalone:true}" class="anexo-input" />
              <input type="text" placeholder="Título (opcional)" [(ngModel)]="novoModeloLinkTitulo" [ngModelOptions]="{standalone:true}" class="anexo-input" />
              <button type="button" class="btn-modern btn-modern-primary btn-sm" (click)="adicionarLinkPendenteModelo()" [disabled]="!novoModeloLinkUrl.trim()">Adicionar</button>
            </div>
          </div>

          <p class="nova-tarefa-form__hint" *ngIf="faltaConteudoModelo">
            Escreva uma descrição, grave um áudio ou anexe um material.
          </p>
          <div class="nova-tarefa-form__acoes">
            <button type="button" class="btn-modern btn-modern-outline btn-sm" (click)="fecharFormularioModelo()" [disabled]="salvandoModelo">
              Cancelar
            </button>
            <button type="submit" class="btn-modern btn-modern-primary btn-sm" [disabled]="salvandoModelo || novoModeloForm.invalid || faltaConteudoModelo">
              <i class="material-icons" *ngIf="!salvandoModelo">save</i>
              <i class="material-icons spin" *ngIf="salvandoModelo">autorenew</i>
              {{ salvandoModelo ? 'Salvando...' : 'Salvar modelo' }}
            </button>
          </div>
        </form>

        <p class="resumo-vazio" *ngIf="modelos.length === 0">Nenhum modelo salvo ainda.</p>
        <ul class="tarefas-lista" *ngIf="modelos.length > 0">
          <li *ngFor="let m of modelos" class="tarefa-item modelo-item">
            <div class="tarefa-item__conteudo">
              <strong>{{ m.titulo }}<span *ngIf="m.temAudio" class="modelo-audio-badge">🎧 áudio</span></strong>
              <p *ngIf="m.descricao">{{ m.descricao }}</p>
              <div class="tarefa-anexos__lista" *ngIf="m.anexos?.length">
                <div class="tarefa-anexo" *ngFor="let a of m.anexos">
                  <a *ngIf="a.tipo === TipoAnexo.Link; else arquivoModeloTpl" [href]="a.url" target="_blank" rel="noopener" class="tarefa-anexo__item">
                    <i class="material-icons">link</i>{{ a.nomeOriginal }}
                  </a>
                  <ng-template #arquivoModeloTpl>
                    <button type="button" class="tarefa-anexo__item" (click)="abrirAnexoModelo(a)">
                      <i class="material-icons">{{ a.contentType && a.contentType.startsWith('image') ? 'image' : 'description' }}</i>{{ a.nomeOriginal }}
                    </button>
                  </ng-template>
                  <button type="button" class="tarefa-anexo__remover" (click)="removerAnexoModelo(m, a)"
                          [disabled]="anexoOcupadoModeloId === m.id" title="Remover anexo">
                    <i class="material-icons">close</i>
                  </button>
                </div>
              </div>
            </div>
            <div class="modelo-item__acoes">
              <button type="button" class="btn-modern btn-modern-primary btn-sm"
                      [disabled]="aplicandoModeloId === m.id" (click)="aplicarModelo(m)" title="Criar tarefa para este paciente">
                <i class="material-icons" *ngIf="aplicandoModeloId !== m.id">playlist_add_check</i>
                <i class="material-icons spin" *ngIf="aplicandoModeloId === m.id">autorenew</i>
                Aplicar
              </button>
              <button type="button" class="btn-modern btn-modern-danger btn-sm"
                      [disabled]="excluindoModeloId === m.id" (click)="excluirModelo(m)" title="Excluir modelo">
                <i class="material-icons">delete</i>
              </button>
            </div>
          </li>
        </ul>
      </div>

      <!-- Formulário de nova tarefa -->
      <form *ngIf="mostrarFormularioTarefa" [formGroup]="novaTarefaForm" class="nova-tarefa-form" (ngSubmit)="salvarNovaTarefa()">
        <div class="row">
          <mat-form-field class="col-xl-8" appearance="outline">
            <mat-label>Título</mat-label>
            <input matInput formControlName="titulo" required maxlength="150" placeholder="Ex.: Registro diário de humor" />
            <mat-error *ngIf="novaTarefaForm.controls['titulo'].hasError('required')">Campo obrigatório</mat-error>
          </mat-form-field>
          <mat-form-field class="col-xl-4" appearance="outline">
            <mat-label>Prazo (opcional)</mat-label>
            <input matInput type="date" formControlName="dataPrazo" />
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="col-xl-12" appearance="outline">
            <mat-label>Descrição / instruções (opcional se gravar áudio)</mat-label>
            <textarea matInput formControlName="descricao" rows="3" maxlength="2000"
                      placeholder="Descreva a tarefa que o paciente deverá executar..."></textarea>
          </mat-form-field>
        </div>
        <div class="nova-tarefa-form__audio">
          <span class="nova-tarefa-form__audio-label">Orientação em áudio (opcional)</span>
          <app-audio-recorder rotuloGravar="Gravar orientação"
                              (gravado)="aoGravarAudioTarefa($event)"></app-audio-recorder>
        </div>

        <div class="nova-tarefa-form__anexos">
          <span class="nova-tarefa-form__audio-label">Materiais de apoio (opcional)</span>
          <div class="tarefa-anexos__lista" *ngIf="anexosPendentesTarefa.length || linksPendentesTarefa.length">
            <div class="tarefa-anexo" *ngFor="let f of anexosPendentesTarefa; let i = index">
              <span class="tarefa-anexo__item"><i class="material-icons">description</i>{{ f.name }}</span>
              <button type="button" class="tarefa-anexo__remover" (click)="removerAnexoPendenteTarefa(i)" title="Remover"><i class="material-icons">close</i></button>
            </div>
            <div class="tarefa-anexo" *ngFor="let l of linksPendentesTarefa; let i = index">
              <span class="tarefa-anexo__item"><i class="material-icons">link</i>{{ l.titulo || l.url }}</span>
              <button type="button" class="tarefa-anexo__remover" (click)="removerLinkPendenteTarefa(i)" title="Remover"><i class="material-icons">close</i></button>
            </div>
          </div>
          <div class="tarefa-anexos__acoes">
            <label class="btn-modern btn-modern-outline btn-sm anexo-file-label">
              <i class="material-icons">attach_file</i> Anexar arquivo
              <input type="file" accept="image/*,application/pdf" hidden (change)="onArquivoNovaTarefa($event)" />
            </label>
            <button type="button" class="btn-modern btn-modern-outline btn-sm" (click)="mostrarLinkFormNovaTarefa = !mostrarLinkFormNovaTarefa">
              <i class="material-icons">link</i> Adicionar link
            </button>
          </div>
          <div class="tarefa-anexos__link-form" *ngIf="mostrarLinkFormNovaTarefa">
            <input type="url" placeholder="https://..." [(ngModel)]="novaTarefaLinkUrl" [ngModelOptions]="{standalone:true}" class="anexo-input" />
            <input type="text" placeholder="Título (opcional)" [(ngModel)]="novaTarefaLinkTitulo" [ngModelOptions]="{standalone:true}" class="anexo-input" />
            <button type="button" class="btn-modern btn-modern-primary btn-sm" (click)="adicionarLinkPendenteTarefa()" [disabled]="!novaTarefaLinkUrl.trim()">Adicionar</button>
          </div>
        </div>

        <p class="nova-tarefa-form__hint" *ngIf="faltaConteudoTarefa">
          Escreva uma descrição, grave um áudio ou anexe um material.
        </p>
        <div class="nova-tarefa-form__acoes">
          <button type="button" class="btn-modern btn-modern-outline btn-sm" (click)="fecharFormularioTarefa()" [disabled]="salvando">
            Cancelar
          </button>
          <button type="submit" class="btn-modern btn-modern-primary btn-sm" [disabled]="salvando || novaTarefaForm.invalid || faltaConteudoTarefa">
            <i class="material-icons" *ngIf="!salvando">save</i>
            <i class="material-icons spin" *ngIf="salvando">autorenew</i>
            {{ salvando ? 'Salvando...' : 'Salvar tarefa' }}
          </button>
        </div>
      </form>

      <!-- Pendentes -->
      <div class="tarefas-secao">
        <span class="tarefas-secao__label">Pendentes ({{ tarefasPendentes.length }})</span>
        <ul class="tarefas-lista" *ngIf="tarefasPendentes.length > 0; else semPendentes">
          <li *ngFor="let t of tarefasPendentes" class="tarefa-item tarefa-item--pendente">
            <div class="tarefa-item__conteudo">
              <strong>{{ t.titulo }}</strong>
              <p *ngIf="t.descricao">{{ t.descricao }}</p>
              <app-audio-player *ngIf="t.temAudioInstrucao"
                                rotulo="Ouvir orientação"
                                [duracaoSegundos]="t.audioInstrucaoDuracaoSegundos"
                                [carregar]="carregadorAudioInstrucao(t)"></app-audio-player>
              <small>
                Criada em {{ t.dataCriacao | date: 'dd/MM/yyyy' }}
                <span *ngIf="t.dataPrazo"> · Prazo: {{ t.dataPrazo | date: 'dd/MM/yyyy' }}</span>
                <span *ngIf="t.dataVisualizacao" class="tarefa-visualizada">
                  · Visualizada em {{ t.dataVisualizacao | date: 'dd/MM/yyyy' }}
                </span>
              </small>

              <!-- Anexos -->
              <div class="tarefa-anexos">
                <div class="tarefa-anexos__lista" *ngIf="t.anexos?.length">
                  <div class="tarefa-anexo" *ngFor="let a of t.anexos">
                    <a *ngIf="a.tipo === TipoAnexo.Link; else arquivoTpl" [href]="a.url" target="_blank" rel="noopener" class="tarefa-anexo__item">
                      <i class="material-icons">link</i>{{ a.nomeOriginal }}
                    </a>
                    <ng-template #arquivoTpl>
                      <button type="button" class="tarefa-anexo__item" (click)="abrirAnexoArquivo(a)">
                        <i class="material-icons">{{ a.contentType && a.contentType.startsWith('image') ? 'image' : 'description' }}</i>{{ a.nomeOriginal }}
                      </button>
                    </ng-template>
                    <button type="button" class="tarefa-anexo__remover" (click)="removerAnexo(t, a)"
                            [disabled]="anexoOcupadoId === t.id" title="Remover anexo">
                      <i class="material-icons">close</i>
                    </button>
                  </div>
                </div>
                <div class="tarefa-anexos__acoes">
                  <label class="btn-modern btn-modern-outline btn-sm anexo-file-label">
                    <i class="material-icons">attach_file</i> Anexar arquivo
                    <input type="file" accept="image/*,application/pdf" hidden
                           (change)="onArquivoSelecionado(t, $event)" [disabled]="anexoOcupadoId === t.id" />
                  </label>
                  <button type="button" class="btn-modern btn-modern-outline btn-sm"
                          (click)="abrirLinkForm(t)" [disabled]="anexoOcupadoId === t.id">
                    <i class="material-icons">link</i> Adicionar link
                  </button>
                </div>
                <div class="tarefa-anexos__link-form" *ngIf="linkFormTarefaId === t.id">
                  <input type="url" placeholder="https://..." [(ngModel)]="novoLinkUrl" class="anexo-input" />
                  <input type="text" placeholder="Título (opcional)" [(ngModel)]="novoLinkTitulo" class="anexo-input" />
                  <button type="button" class="btn-modern btn-modern-primary btn-sm"
                          (click)="adicionarLink(t)" [disabled]="!novoLinkUrl.trim() || anexoOcupadoId === t.id">Adicionar</button>
                  <button type="button" class="btn-modern btn-modern-outline btn-sm" (click)="fecharLinkForm()">Cancelar</button>
                </div>
              </div>
            </div>
            <button type="button"
                    class="btn-modern btn-modern-danger btn-sm"
                    [disabled]="cancelandoId === t.id"
                    (click)="cancelarTarefa(t)"
                    title="Cancelar tarefa">
              <i class="material-icons" *ngIf="cancelandoId !== t.id">block</i>
              <i class="material-icons spin" *ngIf="cancelandoId === t.id">autorenew</i>
              Cancelar
            </button>
          </li>
        </ul>
        <ng-template #semPendentes>
          <p class="resumo-vazio">Nenhuma tarefa pendente.</p>
        </ng-template>
      </div>

      <!-- Concluídas -->
      <div class="tarefas-secao" *ngIf="tarefasConcluidas.length > 0">
        <span class="tarefas-secao__label">Concluídas ({{ tarefasConcluidas.length }})</span>
        <ul class="tarefas-lista">
          <li *ngFor="let t of tarefasConcluidas" class="tarefa-item tarefa-item--concluida">
            <div class="tarefa-item__conteudo">
              <strong>{{ t.titulo }}</strong>
              <small>
                Concluída em {{ t.dataConclusao | date: 'dd/MM/yyyy' }}
                <span *ngIf="t.respostaTexto || t.respostaTemAudio"> · com resposta</span>
              </small>
              <p *ngIf="t.respostaTexto" class="tarefa-resposta">"{{ t.respostaTexto }}"</p>
              <app-audio-player *ngIf="t.respostaTemAudio"
                                rotulo="Ouvir resposta do paciente"
                                [duracaoSegundos]="t.respostaAudioDuracaoSegundos"
                                [carregar]="carregadorRespostaAudio(t)"></app-audio-player>
              <div class="tarefa-anexos__lista" *ngIf="t.anexos?.length">
                <div class="tarefa-anexo" *ngFor="let a of t.anexos">
                  <a *ngIf="a.tipo === TipoAnexo.Link; else arquivoConclTpl" [href]="a.url" target="_blank" rel="noopener" class="tarefa-anexo__item">
                    <i class="material-icons">link</i>{{ a.nomeOriginal }}
                  </a>
                  <ng-template #arquivoConclTpl>
                    <button type="button" class="tarefa-anexo__item" (click)="abrirAnexoArquivo(a)">
                      <i class="material-icons">{{ a.contentType && a.contentType.startsWith('image') ? 'image' : 'description' }}</i>{{ a.nomeOriginal }}
                    </button>
                  </ng-template>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- Canceladas -->
      <div class="tarefas-secao" *ngIf="tarefasCanceladas.length > 0">
        <span class="tarefas-secao__label">Canceladas ({{ tarefasCanceladas.length }})</span>
        <ul class="tarefas-lista">
          <li *ngFor="let t of tarefasCanceladas" class="tarefa-item tarefa-item--cancelada">
            <div class="tarefa-item__conteudo">
              <strong>{{ t.titulo }}</strong>
              <small>Cancelada</small>
            </div>
          </li>
        </ul>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn-modern btn-modern-outline" (click)="fechar()">
    <i class="material-icons">close</i>
    Fechar
  </button>
</div>
